import React from "react";
import { NavLink } from 'react-router-dom';
import jiwakilisheLogo from '../assets/images/jiwakilishe_logo.png';
import thriveEmpowermentLogo from '../assets/images/thrive_empowerment_logo.jpg';
import tioConsultancyLogo from '../assets/images/tio_consultancy_logo.png';
import youthALiveKenyaLogo from '../assets/images/youth_alive_kenya_logo.png';
import '../index.css'

function About(){
    return(
        <section className="container-fluid px-3 px-md-5 py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    {/* Section Header */}
                    <div className="text-center mb-5">
                        <div className="mb-3">
                            <span className="badge bg-primary-light text-primary px-3 py-2 rounded-pill">
                                Collaboration
                            </span>
                        </div>
                        <h2 className="text-display mb-4" style={{fontSize: 'clamp(2rem, 4vw, 3rem)', color: 'var(--gray-800)'}}>
                            Our Partners
                        </h2>
                        <p className="lead text2 text-muted mb-5" style={{fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto'}}>
                            Together with our trusted partners, we're building a stronger future for African youth through collaborative impact.
                        </p>
                    </div>

                    {/* Partners Grid */}
                    <div className="row g-4 justify-content-center">
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a 
                                href="https://www.facebook.com/p/Jiwakilishe-CBO-100063469526714/" 
                                target="_blank" 
                                className="text-decoration-none" 
                                rel="noopener noreferrer"
                            >
                                <div className="partners-card animate-fade-in-up">
                                    <div className="text-center">
                                        <img 
                                            src={jiwakilisheLogo} 
                                            alt="Jiwakilishe Logo" 
                                            style={{maxHeight: '80px', maxWidth: '150px', objectFit: 'contain'}}
                                        />
                                    </div>
                                    <h6 className="text-center text1 mt-3 mb-0" style={{color: 'var(--gray-700)', fontSize: '1rem'}}>
                                        Jiwakilishe
                                    </h6>
                                    <small className="text-center d-block text-muted mt-1">
                                        Community Based Organization
                                    </small>
                                </div>
                            </a>
                        </div>

                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a 
                                href="https://www.instagram.com/thrive_empowerment_org/" 
                                target="_blank" 
                                className="text-decoration-none" 
                                rel="noopener noreferrer"
                            >
                                <div className="partners-card animate-fade-in-up" style={{animationDelay: '0.1s'}}>
                                    <div className="text-center">
                                        <img 
                                            src={thriveEmpowermentLogo} 
                                            alt="Thrive Empowerment Logo" 
                                            style={{maxHeight: '80px', maxWidth: '80px', objectFit: 'contain', borderRadius: '50%'}}
                                        />
                                    </div>
                                    <h6 className="text-center text1 mt-3 mb-0" style={{color: 'var(--gray-700)', fontSize: '1rem'}}>
                                        Thrive Empowerment
                                    </h6>
                                    <small className="text-center d-block text-muted mt-1">
                                        Youth Empowerment
                                    </small>
                                </div>
                            </a>
                        </div>

                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a 
                                href="#tio_consultancy" 
                                className="text-decoration-none" 
                                rel="noopener noreferrer"
                            >
                                <div className="partners-card animate-fade-in-up" style={{animationDelay: '0.2s'}}>
                                    <div className="text-center">
                                        <img 
                                            src={tioConsultancyLogo} 
                                            alt="TIO Consultancy Logo" 
                                            style={{maxHeight: '80px', maxWidth: '80px', objectFit: 'contain', borderRadius: '50%'}}
                                        />
                                    </div>
                                    <h6 className="text-center text1 mt-3 mb-0" style={{color: 'var(--gray-700)', fontSize: '1rem'}}>
                                        TIO Consultancy
                                    </h6>
                                    <small className="text-center d-block text-muted mt-1">
                                        Mental Health Support
                                    </small>
                                </div>
                            </a>
                        </div>

                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a 
                                href="https://youthalivekenya.org/" 
                                target="_blank" 
                                className="text-decoration-none" 
                                rel="noopener noreferrer"
                            >
                                <div className="partners-card animate-fade-in-up" style={{animationDelay: '0.3s'}}>
                                    <div className="text-center">
                                        <img 
                                            src={youthALiveKenyaLogo} 
                                            alt="Youth Alive Kenya Logo" 
                                            style={{maxHeight: '80px', maxWidth: '150px', objectFit: 'contain'}}
                                        />
                                    </div>
                                    <h6 className="text-center text1 mt-3 mb-0" style={{color: 'var(--gray-700)', fontSize: '1rem'}}>
                                        Youth Alive Kenya
                                    </h6>
                                    <small className="text-center d-block text-muted mt-1">
                                        Youth Development
                                    </small>
                                </div>
                            </a>
                        </div>
                    </div>

                    {/* Call to Action */}
                    <div className="text-center mt-5">
                        <div className="card-glass p-4 rounded-4 d-inline-block">
                            <h5 className="text1 mb-3" style={{color: 'var(--gray-800)'}}>
                                Want to Partner With Us?
                            </h5>
                            <p className="text2 text-muted mb-3" style={{maxWidth: '400px'}}>
                                Join our network of partners making a difference in youth empowerment across Africa.
                            </p>
                            <NavLink to="/#contact" className="btn-modern btn-primary"
                                onClick={(e) => {
                                  // If we're already on the home page, scroll to contact
                                  if (window.location.pathname === '/') {
                                    e.preventDefault();
                                    const contactSection = document.getElementById('contact');
                                    if (contactSection) {
                                      contactSection.scrollIntoView({ behavior: 'smooth' });
                                    }
                                  }
                                }}
                            >
                                <i className="bi bi-handshake me-2"></i>
                                Get In Touch
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About